const Dashboard = () => {
  return <></>;
};

export default Dashboard;
